const S_CALLBACK_PHONE_FORM = '.js-callback-phone-form';
const S_PHONE = '.js-phone';
const S_CALLBACK_FORM = '.js-callback-form';
const S_CALLBACK_BTN = '.js-callback-btn';
const S = 'show'
const SD = 'showed'
const A = 'active'
let xhr;

function mouseenter () {
  this.classList.add(S)
  setTimeout(() => {
    this.classList.remove(S)
    this.classList.add(SD)
  }, 500)
  window.clickout.destroy(this);
  window.clickout.bindCustomEvent(this);
}

function mouseleave () {
  this.classList.remove(SD)
  window.clickout.bindCustomEvent(this);
}


function callAlert (data) {
  let random = Math.floor(Math.random() * 10e8);
  document.body.insertAdjacentHTML('beforeend', `<div id="alert-${random}" class="alert-fixed alert-fixed-${data.type}">${data.message}</div>`)
  setTimeout(() => {
    let alert = document.getElementById('alert-' + random)
    alert.classList.add(A)

    function deactivation () {
      alert.classList.remove(A)
      setTimeout(() => {
        alert.remove()
      }, 1000)
    }

    let timeout = setTimeout(deactivation, 4000)

    on(alert, 'click', function () {
      clearTimeout(timeout)
      deactivation()
    })
  }, 100)
}

function submitCallbackForms (e) {
  e && e.preventDefault();

  let th = this
  let showed = th.classList.contains(SD)
  if (!showed) {
    return
  }

  // let nameInput = th.querySelector('.js-name')
  let phoneInput = th.querySelector('.js-phone')
  let agreementInput = th.querySelector('input[name="personal_data_agreement"]')
  let agreementError = th.querySelector('.js-personal-data-agreement-error')
  let yandexMetrikaInput = th.querySelector('input[name="yandex_client_id"]')

  let validName = true
  // if(nameInput){
  //   let nameError = nameInput && nameInput.parentElement.querySelector('.js-error')
  //   let name = nameInput.value.trim()
  //   let validName = name.length > 0;
  //   if (!validName) {
  //     nameError.innerHTML = 'Пожалуйста, укажите имя.'
  //   } else {
  //     nameError.innerHTML = ''
  //   }
  // }

  let phoneError = phoneInput && phoneInput.parentElement.querySelector('.js-error')

  // let name = nameInput.value || '';
  let phone = phoneInput.value
  phone = phone.replace(/[^0-9]/g, '');

  let validPhone = (phone.length >= 11);
  let validAgreement = agreementInput && agreementInput.checked;
  let valid = validPhone && validName && validAgreement;

  if (!validPhone) {
    phoneError.innerHTML = 'Пожалуйста, укажите телефон. Не&nbsp;менее&nbsp;11&nbsp;цифр.'
  } else {
    phoneError.innerHTML = ''
  }
  if (!validAgreement) {
    agreementError && (agreementError.innerHTML = 'Пожалуйста, подтвердите согласие на обработку персональных данных.')
  } else {
    agreementError && (agreementError.innerHTML = '')
  }
  if (valid) {
    th.classList.add('loading')
    window.ym && ym(55295455,'reachGoal','callback-phone');
    xhr(th.getAttribute('method'), th.getAttribute('action'), function (data) {
      if (data) {
        data = JSON.parse(data)
        callAlert(data);
        th.reset();
        th.classList.remove('loading')
        if (!th.classList.contains('sended')) {
          th.classList.add('sended-animated')
          setTimeout(function () {
            th.classList.add('sended')
            th.classList.remove('sended-animated')
          }, 500)
        }
      }
    }, {
      date: new Date(),
      yandex_client_id: yandexMetrikaInput ? yandexMetrikaInput.value : null,
      personal_data_agreement: agreementInput && agreementInput.checked ? 1 : 0,
      // name,
      phone,
      type: th.querySelector('[name="type"]').value,
      _token: th.querySelector('[name="_token"]').value,
    }, function (xhr) {
      let response = null
      try {
        response = JSON.parse(xhr.response)
      } catch (e) {}
      callAlert(response || {
        type: 'error',
        message: 'Ошибка при отправке.'
      });
      th.classList.remove('loading')
    })
  }
}

function clickCallbackBtn () {
  // submitCallbackForms.call(this.callbackForm)
}

function inputPhone () {
  off(this, 'input', inputPhone)
  window.ym && ym(55295455,'reachGoal','callback-phone-input');
}

export default function () {
  xhr = window.getXHR()

  document.querySelectorAll(S_CALLBACK_FORM).forEach(function (value) {
    on(value, 'mouseenter', mouseenter)
    on(value, 'mouseleave', mouseleave)
    on(value, 'clickout', mouseleave)
    on(value, 'submit', submitCallbackForms)
    let btn = value.querySelector(S_CALLBACK_BTN)
    btn.callbackForm = value
    on(btn, 'click', clickCallbackBtn)
  })
  document.querySelectorAll(S_CALLBACK_PHONE_FORM).forEach(function (value) {
    on(value, 'submit', submitCallbackForms)
    let btn = value.querySelector(S_CALLBACK_BTN)
    btn.callbackForm = value
    on(btn, 'click', clickCallbackBtn)
  })
  document.querySelectorAll(S_PHONE).forEach(function (phone) {
    on(phone, 'input', inputPhone)
  })
}
